export default __webpack_public_path__ + "static/media/house-normal.fd4ed429.gif";